import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { usePageSEO } from '@/hooks/usePageSEO';
import { PUBLIC_PAGES } from '@/lib/seo/public-routes';
import { pageMetadata } from '@/lib/seo/metadata';
import { blogPosts } from '@/lib/blog';
import { PublicContainer } from '@/components/layouts/PublicContainer';

function formatDate(date: string) {
  return new Date(`${date}T00:00:00Z`).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

const Blog: React.FC = () => {
  usePageSEO(pageMetadata(PUBLIC_PAGES.blogIndex));

  return (
    <div className="bg-background py-24 sm:py-32">
      <PublicContainer>
        <div className="mx-auto max-w-3xl">
          <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">Blog</h1>
          <p className="mt-2 text-lg leading-8 text-muted-foreground">
            Notes on how DebtDrone works, what we're building, and how we think about technical debt.
          </p>

          <div className="mt-10 space-y-4">
            {blogPosts.length === 0 && (
              <p className="text-sm text-muted-foreground">No posts yet — check back soon.</p>
            )}
            {blogPosts.map((post) => (
              <Link
                key={post.frontmatter.slug}
                to={`/blog/${post.frontmatter.slug}`}
                className="group block rounded-xl border border-hairline bg-surface-1 p-5 transition-colors hover:bg-surface-2"
              >
                <div className="mono text-[11px] uppercase tracking-wider text-muted-foreground">
                  {formatDate(post.frontmatter.date)}
                </div>
                <h2 className="mt-2 text-lg font-medium text-foreground">{post.frontmatter.title}</h2>
                <p className="mt-1 text-sm leading-6 text-muted-foreground">{post.frontmatter.excerpt}</p>
                <div className="mt-3 inline-flex items-center gap-1.5 text-[13px] font-medium text-lime">
                  Read post
                  <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </PublicContainer>
    </div>
  );
};

export default Blog;
